<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import Cache from '@services/Cache';
import apiClient from '@services/ApiClient';

export default {
    name: 'ResendReasonByFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];

            if (Cache.get('returnorder-resend-reasons-by')) {
                options = Cache.get('returnorder-resend-reasons-by');
            } else {
                await apiClient.get('/vue/returnorders/resendreasonsby')
                    .then((response) => {
                        options = response.data;
                        Cache.set('returnorder-resend-reasons-by', response.data);
                    });
            }

            return options;
        },
    },
};
</script>
